import { ReactElement } from 'react';

import { Table } from '@dreryk/react-components';

import { WaitlistEmptyStatePlaceholder } from '../WaitlistEmptyStatePlaceholder';
import { WaitlistEntryCreateModalOpener } from '../create/WaitlistEntryCreateModal.opener';

import {
   useWaitlistEntriesTableLazyLoadedDataConfigurationByCqrsQuery,
   useWaitlistTableColumnConfiguration,
} from './WaitlistEntriesTable.hooks';

const PAGE_SIZE = 50;

type WaitlistEntriesTableProps = {
   patientSearchText: string | null;
};

export const WaitlistEntriesTable = (props: WaitlistEntriesTableProps): ReactElement => {
   return (
      <Table
         testId={'waitlist'}
         columns={useWaitlistTableColumnConfiguration()}
         dataConfiguration={useWaitlistEntriesTableLazyLoadedDataConfigurationByCqrsQuery(props.patientSearchText)}
         keyExtractor={'id'}
         pageSize={PAGE_SIZE}
         placeholder={
            <WaitlistEntryCreateModalOpener>
               {({ openModal }) => (
                  <WaitlistEmptyStatePlaceholder
                     onAddPatientToTheWaitlistClick={openModal}
                     patientSearchTextEntered={Boolean(props.patientSearchText)}
                  />
               )}
            </WaitlistEntryCreateModalOpener>
         }
      />
   );
};
